export default __webpack_public_path__ + "static/media/payment-plan-deposit-one.53145b96.png";